import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-grid',
  templateUrl: './vehicle-grid.component.html',
  styleUrls: ['./vehicle-grid.component.css']
})
export class VehicleGridComponent implements OnInit {

  title = "Vehicle List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ultilities/vehicle/vehicle-grid/vehicle-grid.component.ts